import { useMutation, useQueryClient } from '@tanstack/react-query';
import { riskCalculationApi } from '@/services/riskCalculationApi';
import { BaseRiskCalculation } from '@/dtos/RiskCalculations/index';
import { toast } from 'sonner';

export function useUpdateReviewStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, inReview }: { id: string; inReview: boolean }) =>
      riskCalculationApi.updateReviewStatus(id, inReview),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Statusul de revizie a fost actualizat cu succes');
        // Invalidate relevant queries to refetch data
        queryClient.invalidateQueries({ queryKey: ['risk-calculations'] });
        queryClient.invalidateQueries({ queryKey: ['flow-clinical-sessions'] });
      } else {
        toast.error(response.errorMessage || 'Eroare la actualizarea statusului de revizie');
      }
    },
    onError: (error) => {
      toast.error('Eroare la actualizarea statusului de revizie');
      console.error('Failed to update review status:', error);
    },
  });
}
